import { jsx as l, jsxs as i } from "react/jsx-runtime";
import "react";
var o = (s) => /* @__PURE__ */ i("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ...s,
  children: [
    /* @__PURE__ */ l("path", {
      fill: "#F0F0F0",
      d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#0052B4",
      d: "M38.756 26.956A19.955 19.955 0 0 0 40 20c0-2.447-.44-4.79-1.244-6.957H1.244A19.957 19.957 0 0 0 0 20c0 2.446.44 4.79 1.244 6.956L20 28.696l18.756-1.74Z"
    }),
    /* @__PURE__ */ l("path", {
      fill: "#D80027",
      d: "M20 40c8.6 0 15.93-5.427 18.756-13.044H1.244C4.07 34.573 11.401 40 20 40Z"
    })
  ]
});
export {
  o as default
};
